<template>
<b-container class="container">
  <b-collapse v-model="btn_toggle">
     <b-button size="sm"  @click="addbooth"
       variant="primary">
       Add Booth
     </b-button>
  </b-collapse>
  <b-collapse v-model="addbooth_toggle">
  <b-row class="mt-1">
  <b-col>
    <label>Booth Name</label>
    <b-form-input v-model="edit.title" maxlength="150"></b-form-input>
    <b-collapse v-model="title_error">
    <label class="error">Title is required</label>
    </b-collapse>
  </b-col>
  </b-row>

  <b-row class="mt-1">
  <b-col>
     <label>Description (optional)</label>
     <b-form-textarea v-model="edit.description" rows="3" max-rows="6" maxlength="600"></b-form-textarea>
  </b-col>
  </b-row>
  <b-row class="mt-1">
  <b-col>
     <label>Company URL (optional)</label>
     <b-form-input v-model="edit.url" rows="3" max-rows="6"></b-form-input>
  </b-col>
  </b-row>
  <b-row class="mt-1">
    <b-col>
     <label>Booth Banner (optional)</label>
    </b-col>
  </b-row>

  <b-row>
    <b-col>
     <upload-image       
       v-model="edit.banner"
       :evid="$parent.event.id"
       :imgkind="'booth'+edit.id+'-banner'"
       optional="true"
     />
   </b-col>
  </b-row>

  <b-row v-if="this.$parent.event.groups.length > 1">
  <b-col>
    <label>Ticket tier for the booth</label>
  </b-col>
  <b-col>
     <b-form-select v-model="selectedgroup">
        <b-form-select-option v-for="group in this.$parent.event.groups" :value="group.name">{{ to_disp_name(group.name) }}</b-form-select-option>
     </b-form-select>
     <b-collapse v-model="group_error">
     <label class="error">Tier has to be selected</label>
     </b-collapse>
  </b-col>
  </b-row>

     <ev-sess-mod
       :ev="$parent.event"
       :ss="edit"
       startend="true"
       :startep="$parent.event.startep"
       :endep="$parent.event.endep"
     />

  <b-row><b-col>
    <b-button v-bind:disabled="isSubmitDisabled" size="sm"
      v-on:click="update"
      variant="primary">
      Submit
    </b-button> 
    <b-button v-on:click="cancelbooth" size="sm"
      variant="outline-danger">
      Cancel
    </b-button>
     <confirm-del class="float-right" variant="danger"
        v-on:confirmed-delete="deletebooth()">
     </confirm-del> 
     <b-collapse v-model="event_success">
     <label class="message">Booth has been added</label>
     </b-collapse>
     <b-collapse v-model="event_failure">
     <label class="error">Booth couldn't be created due to an error</label>
     </b-collapse>
  </b-col></b-row>
  <br><br>
  </b-collapse>

  <b-collapse v-model="btn_toggle">
 <label v-if="!$parent.event.booths.length && addbooth_toggle==false"><b>No booths in this event.</b></label>
 <b-collapse v-model="showdeck">
  <b-card-group deck v-if="$parent.event.booths.length">
    <b-card v-for="(booth,index) in this.$parent.event.booths"
        :title="booth.title" class="event_card"
        :img-src="booth.banner"
        img-width="150" img-height="200">
    <!--label v-if="booth.start_ep"><b>{{ datestring(booth) }}</b></label><br-->
  <b-link v-if="booth.url" @click="openbio(booth.url)"><b>Booth Link</b></b-link><br>
  <b><b-row v-for="mod in booth.moderators"><b-col cols="4">Moderator:</b-col><b-col> {{ mod.name }}<br>{{ datestring(mod) }}</b-col></b-row></b><br>
    <b-card-text v-if="booth.description" class="para">{{ booth.description }}
    </b-card-text>
      <b-button variant="primary" size="sm"
        @click="editbooth(index)">
        Edit Booth
     </b-button>
    </b-card>
  </b-card-group>
  </b-collapse>
 </b-collapse>
</b-container>
</template>
<script>

import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";
import DatePicker from "vue2-datepicker";
import UploadImage from "../components/UploadImage";
import EvSessMod from "../components/EvSessMod"
import ConfirmDel from "../components/ConfirmDel";

export default {
  name: "update_booths",
  data() {
    return {
       edit: {
         title: '',
         description: '',
         url: '',
         banner: 'https://images.freeimages.com/images/large-previews/1ce/stars-1194599.jpg',
       },
       currentbooth: 0,
       btn_toggle: true,
       addbooth_toggle: false,
       title_error: false,
       description_error: false,
       file_error: false,
       selectedgroup: '',
       group_error: false,
       speaker: '',
       speakerbio: '',
       event_success: false,
       event_failure: false,
       isSubmitDisabled: false,
       showdeck: true,
    };
  },
  components: {
    DatePicker,
    UploadImage,
    EvSessMod,
    ConfirmDel,
  },
  created() {
  },
  computed: {
  },
  methods: {
    datestring: utils.datestring,
    openbio: utils.openbio,
    to_disp_name: function(groupname) {
        var idx = groupname.indexOf("-");
        var subs = groupname.substring(idx+1);
        return subs.replaceAll("-"," ");
    },
    addbooth: function () {
        this.event_success = false;
        this.group_error = false;
        this.title_error = false;
        this.isDelete = false;

        this.addbooth_toggle = true;
        this.btn_toggle = false;
        this.isSubmitDisabled = false;

        this.currentbooth = this.$parent.event.booths.length;
        this.edit = {
          title: '',
          description: '',
          url: '',
          banner: 'https://images.freeimages.com/images/large-previews/1ce/stars-1194599.jpg',
          moderators:[],
        };
        this.edit.kind = "booth";
        this.edit.id = utils.new_id(this.$parent.event);
        this.edit.roomname = this.$parent.acc+"/:e:"+this.$parent.event.id+"-booth-"+this.edit.id;
    },
    cancelbooth: function () {
       let vue = this;
             this.addbooth_toggle = false;
              this.btn_toggle = true;
          vue.$parent.notify({
             action:"SESSION_EDIT_DONE",
            sessionid: vue.edit.id,
          });
    },
    deletebooth: function () {
        let vue = this;
        this.isDelete = true;
        /* Only need to send what changed */
        let event = {sessions:[],delta:true};
        event.id = this.$parent.event.id;
        this.edit.rem = true;
        utils.session_modified(this.$parent.event, this.edit);
        event.sessions.push(this.edit);
        window.wss_send(vx, "adm_event_set", {rtag:"booth",
           event: event
        });
        delete vue.edit.rem;

        vue.edit.moderators.forEach(function(m) {
           if (!m.email) { return; }
           window.wss_send(vx, "adm_event_add_attendee", {
             rtag:"booth",
             event: {
               id: vue.$parent.event.id,
             },
             att: {
               em: m.email,
               access: [{
                 id: vue.edit.id+"-"+m.id,
                 rem: true,
               }]
            }
          });
        }); // moderators
    },
    editbooth: function(index) {
        this.event_success = false;
        this.group_error = false;
        this.title_error = false;
        this.currentbooth = index;
        this.isDelete = false;

        this.edit = {};
        this.edit.kind = "booth";
        this.edit.id = this.$parent.event.booths[this.currentbooth].id;
        this.edit.ver = this.$parent.event.booths[this.currentbooth].ver;
        this.edit.pver = this.$parent.event.booths[this.currentbooth].pver;
        this.edit.title = this.$parent.event.booths[this.currentbooth].title;
        this.edit.description = this.$parent.event.booths[this.currentbooth].description;
        this.edit.roomname = this.$parent.event.booths[this.currentbooth].roomname;
        this.edit.url = this.$parent.event.booths[this.currentbooth].url;
        this.edit.banner = this.$parent.event.booths[this.currentbooth].banner;
        this.edit.moderators = this.$parent.event.booths[this.currentbooth].moderators;
              this.selectedgroup = this.$parent.event.booths[this.currentbooth].selectedgroup;

        this.addbooth_toggle = true;
        this.btn_toggle = false;
        this.isSubmitDisabled = false;

        this.$parent.notify({
          // em, full_admin, code are filled in by the server
          action:"SESSION_EDIT_START",
          sessionid: this.edit.id
        });
        window.scrollTo(0,0);
    },
    update: function() {
        let ev = this.$parent.event;
        let vue = this;
        this.file_error = false;
        this.title_error = false;
        if (!this.edit.title) {
          this.title_error = true;
          return;
        }

        if (!this.selectedgroup) {
                if (ev.groups.length == 1) {
                        this.selectedgroup = ev.id + "-freeaccess";
                } else {
                        this.group_error = true;
                        console.log("grouperror");
                        return;
                }
        }
        
        this.edit.selectedgroup = this.selectedgroup;
        this.isSubmitDisabled = true;
      
        /* Step 1 -- create room */
        window.wss_send(vx, "adm_event_add_room", {rtag:"booth",
          event: {
             id: vue.$parent.event.id
          }, group: {
             name: vue.edit.selectedgroup
          },
          ctrl: {
             name: vue.edit.roomname,
             dname: vue.edit.title
           }
        });
    },
    setup: function() {
      let vue = this;
      if (!vue.$parent.event.id) { return; }
      vue.start_date = new Date(this.$parent.event.startep);
    }
  },
  watch: {
     '$parent.event.id': function(to, from) {
         this.setup();
     }
  },
  beforeDestroy() {
     window.wss_clr_routes(window.vx,"update_booths");
  },
  mounted() {
    let vue = this;
    vue.event_success = false;
    vue.setup();
    window.wss_open(vx, {
      acc: vue.$parent.acc,
      uid: vx.user.id,
      routes_id: "update_booths",
      routes: {
        adm_room_list: function(msg) {
        },
        adm_event_add_room: function(msg) {
           if (msg.rtag != "booth") return;
           if (msg.data.error &&
               msg.data.error != "event already includes room") {
                   vue.$parent.toast("err","add_room error "+msg.data.error);
                   console.warn(msg.data.error);
                   return;
           }

           vue.$parent.event.booths[vue.currentbooth] = vue.edit;
           vue.edit.moderators.forEach(function(m) {
              if (!m.email) { return; }
              window.wss_send(vx, "adm_event_add_attendee", {
                rtag:"booth",
                event: {
                  id: vue.$parent.event.id,
                },
                att: {
                  em: m.email,
                  name: m.name,
                  access: [{
                     id: vue.edit.id+"-"+m.id,
                     roomname:vue.edit.roomname,
                     startep: m.startep,
                     endep: m.endep,
                     is_mod: true,
                  }]
                }
              });
            }); // moderators

            /* Step 3 - update event */
          utils.session_modified(vue.$parent.event,vue.edit);
          let event = {sessions:[],delta:true};
          event.id = vue.$parent.event.id;
          event.sessions.push(vue.edit);
          window.wss_send(vx, "adm_event_set", {rtag:"booth",
             event: event
          });
        },
        adm_event_set: function(msg) {
           /* Step 4 - Done */
           if (msg.rtag != "booth") return;
           vue.isSubmitDisabled = false;
           if (msg.data.error) {
                vue.$parent.toast("err","event_set error "+msg.data.error);
                console.warn(msg.data.error);
                vue.event_failure = true;
                return;
           }
           if (msg.data.event) {
              vue.$parent.event = utils.remote_to_local(msg.data.event);
           }

           vue.addbooth_toggle = false;
           vue.btn_toggle = true;
           vue.showdeck = true;
           if (vue.isDelete == true) {
                vue.isDelete = false;
                window.wss_send(vx, "adm_event_rem_room", {rtag:"booth",
                   event: {
                     id: vue.$parent.event.id
                   },
                   roomname: vue.edit.roomname
                });
                vue.showdeck = true;    
                return;
           }

           vue.event_success = true;
        },
        adm_event_rem_room: function(msg) {
           if (msg.rtag != "booth") return;
           if (msg.data.error) {
             console.log(msg.data.error);
             return;
           }
        },
        evnotify: function(msg) {
          if (!msg || !msg.data | !msg.data.sessionid) { return; }
          if (!vue.edit || !vue.edit.id) {
             /* Not currently editing a session */
          } if (vue.edit.id != msg.data.sessionid) {
             /* Editing a different session */
          } else {
             /* Editing the same session */
             if (msg.data.action == "SESSION_EDIT_DONE") {
               vue.$parent.toast("ok", msg.data.em+" stopped editing this booth.");
             } else if (msg.data.action == "SESSION_EDIT_START") {
               vue.$parent.toast("err", msg.data.em+" started editing this booth.");
               vue.$parent.notify({
                 action:"SESSION_EDIT_INPROGRESS",
                 sessionid: vue.edit.id,
               });
             } else if (msg.data.action == "SESSION_EDIT_INPROGRESS") {
               vue.$parent.showconfirm("danger", msg.data.em+" is  currently editing this booth. Are you sure you want to make a change?",
                 null,
                 function() {
                    vue.cancelbooth();
                 }
               );
             }
          }
        },
      }
    });
  }
}
</script> 
<style lang="scss" scoped>
.container {
  max-width: 960px;
}
.event_card {
  min-width: 20rem;
  max-width: 30rem;
  min-height: 10rem;
  margin-top: 10px;
  margin-bottom: 10px;
}
.error {
  color:red;
  padding-top:10px;
  font-weight: 500;
}
.message {
  font-weight: 500;
  color:red;
  padding-top:5px;
}
.para {
  margin-top: 10px;
  white-space:pre-wrap;
}
</style>
